<template>
  <div>
    <div
      class="remind"
      v-if="showModal1"
    >
      <div class="content">
      <img
        src="../../images/contract-signature/back.png"
        class="back"
      />
      <div class="close" @click="showModal1 = false">×</div>
      <div class="box">
        <div class="title">尊敬的客户，您好：</div>
        <div class="info">
          为了更好的保护您的账户安全、健全个人账户功能，同时响应最新的《个人信息安全规范》，请<span v-if="!overdue">在<span class="date font-c" >{{date}}</span>前</span>完成实名认证。您的个人信息将得到绝对的保护。
        </div>
        <div class="decs font-c">温馨提示：如实名认证过程中存在特殊情况，可联系您的专属客服进行解决</div>
      </div>
      <div class="dec">
        <img
          src="../../images/contract-signature/zhu.png"
          class="zhu"
        />
        e签宝向您提供实名认证服务并承担责任。
      </div>
      <div class="btns">
        <div :class="overdue ? 'btn ccc' : 'btn'" @click="cancel">暂不认证</div>
        <div class="btn btn1" @click="contract">去认证</div>
      </div>
      </div>
    
    </div>
    <registerModal ref="registerModalDom" />
  </div>
</template>

<script>
import registerModal from "@/components/new-register/index.vue"
import { certificationAlert } from '@/api/certification'
import momnet from 'moment'
export default {
  components: { registerModal },
  data() {
    return {
      showModal1: false,
      date: '',
      overdue: false,
      propsData: {}
    }
  },
  mounted() {},
  methods: {
    show(data) {
      this.propsData = {
        data: data
      }
        certificationAlert().then((res) => {
          this.overdue = res.data.data.overdue
          this.date = res.data.data.remindEndTime && momnet(res.data.data.remindEndTime).format('YYYY年MM月DD日')
          if(res.data.data.remind){
            this.showModal1 = true
          }else {
            this.$emit('hideRemind',this.propsData)
          }
        })
    },
    cancel() {
      if(!this.overdue){
        this.$emit('hideRemind',this.propsData)
        this.showModal1 = false 
      }
    },
    contract(){
      this.showModal1 = false
      this.$refs['registerModalDom'].show()
    }
  },
}
</script>

<style lang="less">
.remind {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  .content {
    width: 600px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    .back {
      width: 100%;
    }
    .close {
      color: #afd0fd;
      font-size: 35px;
      right: 40px;
      top: 10px;
      position: absolute;
      cursor: pointer;
    }
    .box {
      position: absolute;
      left: 50px;
      top: 55px;
      width: 83%;
    }
    .title {
      font-size: 16px;
      font-weight: bold;
    }
    .info {
      text-indent: 2em;
      font-size: 15px;
      line-height: 25px;
      margin-top: 10px;
      margin-bottom: 20px;
    }
    .decs {
      font-size: 14px;
    }
    .date {
      font-weight: bold;
    }
    .font-c {
      color: #ff9100;
    }
    .dec {
      color: #fff;
      font-size: 14px;
      position: absolute;
      bottom: 115px;
      left: 50%;
      transform: translate(-50%,0);
      .zhu {
        display: inline-block;
        width: 15px;
        vertical-align: text-top;
      }
    }
    .btns {
      position: absolute;
      bottom: 50px;
      left: 50%;
      transform: translate(-50%,0);
      width:71%;
      display: flex;
      justify-content: space-between;
      .btn {
        width: 200px;
        line-height: 35px;
        text-align: center;
        border-radius: 30px;
        box-shadow: 0 4px 0 0 #518ada;
        border: 1px solid #1b7aff;
        font-size: 14px;
        color: #1b7aff;
        cursor: pointer;
      }
      .btn1 {
        background: #1b7aff;
        color: #fff;
      }
      .ccc {
        background: #f1f1f1;
        color: #999;
        border: 1px solid #999;
        cursor: not-allowed;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// remind.vue?66649903